<template>
  <span v-for="(heart, key) in hearts" :key="key">
    <img
      v-if="heart.type == 'full'"
      src="../../assets/coeur_plein.png"
      height="20"
      width="20"
    />
    <img
      v-if="heart.type == 'half'"
      src="../../assets/coeur_demi.png"
      height="20"
      width="20"
    />
    <img
      v-if="heart.type == 'empty'"
      src="../../assets/coeur_vide.png"
      height="20"
      width="20"
    />
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "heart",
  data() {
    return {
      hearts: [],
      lostHeart: 0,
      defaultLife: 0,
    };
  },
  computed: {
    ...mapGetters({
      life: "life",
    }),
  },
  watch: {
    life() {
      this.heartRender();
    },
  },
  mounted() {
    this.defaultLife = this.life;
    this.heartRender();
  },

  methods: {
    heartRender() {
      this.hearts = [];

      if (this.life <= 0) {
        for (let i = 0; i < this.defaultLife; i++) {
          this.hearts.push({ type: "empty" });
        }
        return;
      }

      // si c'est pas un entier (ex: 4.5)
      if (!Number.isInteger(this.life)) {
        for (let i = 0; i < this.life - 0.5; i++) {
          this.hearts.push({ type: "full" });
        }

        if (this.life + 0.5 === this.defaultLife) {
          this.hearts[this.hearts.length] = { type: "half" };
        } else {
          this.hearts.push({ type: "half" });
        }
      } else {
        for (let i = 0; i < this.life; i++) {
          this.hearts.push({ type: "full" });
        }
      }

      this.lostHeart = this.defaultLife - this.life;

      if (!Number.isInteger(this.lostHeart)) {
        for (let i = 0; i < this.lostHeart - 0.5; i++) {
          this.hearts.push({ type: "empty" });
        }
      } else {
        for (let i = 0; i < this.lostHeart; i++) {
          this.hearts.push({ type: "empty" });
        }
      }
    },
  },
};
</script>

<style>
</style>